// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-menu-user-icon{width:34px;height:28px;cursor:pointer}.main-menu-user-icon .user-icon{width:28px;height:28px}.main-menu-user-icon .sort.down.icon{position:relative;top:-14px;left:13px;color:#176179;font-size:1em}", ""]);
// Exports
module.exports = exports;
